import type { ReactNode } from 'react';
import { TableSearch } from './table-search.tsx';
import type { DataTableSearch } from './types.ts';

interface TableToolbarProps {
  search?: DataTableSearch;
  toolbar?: ReactNode;
}

/** The search field and the caller's filters and primary action, above the table. */
export function TableToolbar({ search, toolbar }: TableToolbarProps) {
  if (!search && !toolbar) {
    return null;
  }

  return (
    <div data-slot='data-table-toolbar' className='flex flex-wrap items-center gap-2'>
      {search && <TableSearch {...search} />}
      {toolbar && (
        <div className='flex flex-wrap items-center gap-2 max-mobile:w-full'>
          {toolbar}
        </div>
      )}
    </div>
  );
}
